/** Matches server `SETTINGS.CLIENT_ARCHIVE_REASON.TYPE_CHANGE`. */
export const CLIENT_ARCHIVE_REASON_TYPE_CHANGE = "type_change";

export const TYPE_CHANGE_UNARCHIVE_MESSAGE =
  "This client was archived due to a type change and cannot be restored. Use the replacement client record instead.";

export function isPermanentTypeChangeArchive(client: {
  archiveReason?: string | null;
} | null | undefined): boolean {
  return client?.archiveReason === CLIENT_ARCHIVE_REASON_TYPE_CHANGE;
}

export function canUnarchiveClient(client: {
  archived?: boolean;
  archiveReason?: string | null;
} | null | undefined): boolean {
  return !!client?.archived && !isPermanentTypeChangeArchive(client);
}
